import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Globe, ChevronDown } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export default function Header({ dark = true }) {
  const navigate = useNavigate();
  const { lang, setLang, langs } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <header className="absolute top-0 left-0 right-0 z-30">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button onClick={() => navigate("/")} className="flex items-center group">
          <img src="/logo-supera-light.png" alt="Supera Leadership" className="h-12 w-auto object-contain transition-transform group-hover:scale-[1.04]" />
        </button>

        <div className="relative" ref={ref} data-no-i18n>
          <button
            onClick={() => setOpen((o) => !o)}
            className={`flex items-center gap-1.5 rounded-full border ${
              dark ? "border-white/25 bg-white/10 text-white" : "border-black/10 bg-white text-[#0A1C30]"
            } px-3.5 py-1.5 text-sm font-semibold backdrop-blur-md hover:border-gold transition-colors`}
          >
            <Globe className="w-4 h-4" />
            {lang}
            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
          </button>
          {open && (
            <div className="absolute right-0 mt-2 w-40 rounded-xl bg-white shadow-xl ring-1 ring-black/5 overflow-hidden">
              {langs.map((l) => (
                <button
                  key={l.code}
                  onClick={() => { setLang(l.code); setOpen(false); }}
                  className={`w-full flex items-center justify-between px-4 py-2.5 text-sm font-semibold transition-colors ${
                    lang === l.code ? "bg-[#FBF0CE] text-[#0A1C30]" : "text-[#0A1C30] hover:bg-[#FAF8F1]"
                  }`}
                >
                  <span>{l.label}</span>
                  <span className="text-xs text-[#9AA4B4]">{l.code}</span>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
